<footer class="h-2rem m-0 p-0">
  <p class="text-center" [ngClass]="login ? 'text-white' : 'text-primary'">
    © {{ year }} |
    <a
      class="no-underline"
      [ngClass]="login ? 'text-white' : 'text-primary'"
      href=""
      >Privacidad</a
    >
    |
    <a
      class="no-underline"
      [ngClass]="login ? 'text-white' : 'text-primary'"
      href=""
      >Terminos</a
    >
  </p>
</footer>
